import { useState, useEffect } from "react";

const ThangNamPhanBo = ({ thang, tunam, initialValue, soThang,onChange  }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    const dividedValue = Math.floor(initialValue / soThang) || 0; // Chia đều
    setValue(dividedValue.toLocaleString("vi-VN"));
  }, [initialValue, soThang]); // Khi initialValue hoặc soThang thay đổi, cập nhật value

  const handleChange = (e) => {
    let formattedValue = e.target.value.replace(/\D/g, ""); // Chỉ giữ số
    let newValue = Number(formattedValue);
    setValue(newValue.toLocaleString("vi-VN"));
    onChange(thang,tunam, newValue); // Gửi giá trị lên component cha
  };

  return (
    <div className="col-md-2">
      <div className="form-group">
        <label>Tháng {thang}/{tunam}</label>
        <input
          type="text"
          className="form-control input-sm"
          id={`thangnamphanbo_${thang}_${tunam}`}
          name={`thangnamphanbo_${thang}_${tunam}`}
          onChange={handleChange}
          value={value}
        />
      </div>
    </div>
  );
};

export default ThangNamPhanBo;
